import React, { useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { ATTRIBUTE_TYPE, ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING } from '../../../HelperMethods/FormUtils';
import apiService from '../../../service/apiService';
import * as UtilityFunctions from '../../../HelperMethods/UtilityFunctions';

let debouncedFn = null;

export default function StopSearchComponent({
  setSelectedStop = '',
  selectedStopId = '',
  stopList,
  label = true,
  disabled = false,
  selectedFieldProps = '',
  location = '',
  style = {},
}) {
  const [optionList, setOptionList] = useState({ items: [], isLoading: false });
  const selectedAreas = useSelector((state) => state.appReducer.selectedAreas);
  const allAreas = useSelector((state) => state.appReducer.allAreas);
  const selectedField = useSelector((state) => state.appReducer.selectedField);

  React.useEffect(() => {
    if (!_.isEmpty(stopList)) {
      setOptionList({ items: stopList, isLoading: false });
    } else {
      setOptionList({ items: [], isLoading: false });
    }
  }, [stopList]);

  const attributeOnSearch = (event) => {
    if (_.size(_.get(event, 'target.value', '')) > 2) {
      if (!debouncedFn) {
        debouncedFn = _.debounce(async (val, areas, field, setOptionData, isAreasSelected) => {
          try {
            const optionListTemp = _.cloneDeep(optionList);
            setOptionData({ ...optionListTemp, isLoading: true });
            const reqAreaIds = areas.map((area) => area.id);

            const res = await apiService.getStopsBySearchStringAndFieldids({
              fieldIds: [field.id || selectedFieldProps],
              areaIds: _.isEmpty(location) ? reqAreaIds : [],
              searchString: val,
              isAreasSelected,
            });
            let assets = UtilityFunctions.inflateResponse(res);
            assets = (assets || []).filter((asset) => !asset.isDeleted);
            setOptionData({
              items: assets.map((asset) => {
                return { ...asset, key: asset.id, value: asset.id, text: asset.name };
              }),
              isLoading: false,
            });
          } catch (error) {
            setOptionData({ items: [], isLoading: false });

            console.error(error);
          }
        }, 500);
      }
      debouncedFn(
        _.get(event, 'target.value', ''),
        _.size(selectedAreas) ? selectedAreas : allAreas,
        selectedField,
        setOptionList,
        !!_.size(selectedAreas)
      );
    }
  };

  const attributeOnChange = (event, data) => {
    if (!data?.value) {
      setOptionList({ items: [], isLoading: false });
    }
    setSelectedStop(data.value, optionList?.items?.find?.(item => item?.id === data?.value));
  };

  return (
    <div style={{ display: 'flex', marginRight: '10px', maxWidth: '250px', width: '250px' }}>
      <>
        {label && <label style={{ marginRight: '10px', marginTop: '10px' }}>Stop</label>}

        {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.PICKLIST]({
          name: 'stopsearch',
          value: selectedStopId,
          options: optionList,
          placeholder: 'Search by stops',
          onChange: attributeOnChange,
          onSearchChange: attributeOnSearch,
          disabled,
          style,
          selectOnBlur: false,
        })}
      </>
    </div>
  );
}
